<template>
  <ion-page>
    <master-layout :pageTitle="'تغییر قیمت و موجودی محصول '">
      <ion-card>
        <ion-card-content>
          <Loading :is="!wpLoaded" v-if="!wpLoaded"></Loading>
          <div v-if="wpLoaded">
            <div v-if="wp">
              <div>
                محصول :
                {{wp.product_title}}
              </div>
              <AjaxForm :route="'WarehouseProduct/ChangeBuyPriceAndQuantity/'+wp._id" :callback="formCallback">
                <div class="mt-2">
                  <label>موجودی</label>
                  <input class="form-control" type="tel" name="quantity" :value="wp.quantity">
                </div>
                <div class="mt-2">
                  <label>قیمت خرید</label>
                  <input class="form-control" type="tel" name="buy_price" :value="wp.buy_price">
                </div>
                <div class="">
                  <button class="btn btn-success btn-block btn-lg" type="submit">ثبت تغییرات</button>
                </div>
              </AjaxForm>
            </div>
            <div v-if="error" class="alert alert-danger">
              {{error}}
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {
  IonCard, IonCardTitle, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import Loading from "@/components/Loading";
import AjaxForm from "@/components/AjaxForm";
import {showSystemNoti} from "@/shared/helper";

export default {
  data()
  {
    return {
      id:null,
      wpLoaded: false,
      wp:null,
      error:null,
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
    await this.init();
  },
  components: {
    Loading,AjaxForm,
    IonCard, IonCardTitle, IonCardContent, IonPage
  },
  methods: {
    ...mapActions("warehouse", {
      getWpInfoForChangePrice: 'getWpInfoForChangePrice'
    }),
    ...mapActions("customer", {
      getCustomer: 'getCustomer'
    }),
    async init()
    {
      this.wpLoaded = false;
      this.wp = false;
      const result = await this.getWpInfoForChangePrice(this.id);
      if (result)
      {
        if (result.ok)
        {
          this.wpLoaded = true;
          this.wp = result.w_product;
        }
        else
        {
          this.wpLoaded = true;
          this.error = result.error
        }
      }
      else
      {
        this.wpLoaded = true;
        this.error = 'خطا در برقراری ارتباط با سرور'
      }
    },
    async formCallback(data)
    {
      const self = this;
      if (data.ok)
      {
        showSystemNoti('success',data.message,function (){
          self.$router.push({path : '/WarehouseProduct/List/'+self.wp.warehouse_id})
        })
      }
      else
        showSystemNoti('danger',data.error);
    }
  }, watch: {
    "$route.path": {
      handler(newUrl)
      {
        if (newUrl.toLowerCase().indexOf('warehousewroduct/whangewuantity') >= 0)
        {
          this.loading = true;
          this.init()
        }
      }
    },
  }
};

</script>

<style scoped>
</style>